.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 1rem;
  overflow: hidden;
  gap: 1rem;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  height: 100%;
  max-width: 300px;
  text-align: center;
  font-size: 14px;
  background-color: rgb(250, 250, 250);
  border-radius: 5px;
  border: 1px solid var(--border-grey);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  composes: slideLeft from global;
}
.card:hover {
  background-color: rgb(240, 240, 240);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 1);
  color: black;
  transform: scale(1.05);
  font-weight: bold;
}

.title {
  font-weight: bold;
}

.button {
  margin-top: 1rem;
  width: 80%;
}
